const firebaseConfig = {
  apiKey: "AIzaSyBpGctSAbaR9u9H_lfCaGuuDy--v0OKJI8",
  authDomain: "my-test-project-c235b.firebaseapp.com",
  databaseURL: "https://my-test-project-c235b-default-rtdb.firebaseio.com",
  projectId: "my-test-project-c235b",
  storageBucket: "my-test-project-c235b.appspot.com",
  messagingSenderId: "1093453348161",
  appId: "1:1093453348161:web:9eafa826bffab090f675c0",
  measurementId: "G-PW6XR4M65Q",
};

export default firebaseConfig;
